// PageFrame: the frame every OS page sits in (drawing v2.6, `.page` on every
// screen; os-design-reference.md section 4, widths and breakpoints).
//
// The outer element is the container the breakpoints read (the page's own
// width, so a page inside a panel behaves correctly); the inner one carries
// the padding, the gap between page sections and the width class: Reading
// 720 (forms, settings), Standard 1280 (dashboards, records), Full (lists
// and boards). `hasToast` keeps 96px free at the bottom so a toast never
// covers a button.

import type { ReactNode } from "react";
import { cx } from "./cx";

export type PageWidth = "reading" | "standard" | "full";

export function PageFrame({
  width = "standard",
  hasToast = false,
  className,
  children,
  ...rest
}: {
  width?: PageWidth;
  hasToast?: boolean;
  className?: string;
  children: ReactNode;
  "aria-busy"?: boolean;
  "data-testid"?: string;
}) {
  return (
    <div className="pg-frame" {...rest}>
      <div
        className={cx(
          "pg-page",
          width === "reading" && "pg-page--read",
          width === "standard" && "pg-page--std",
          hasToast && "pg-page--has-toast",
          className,
        )}
      >
        {children}
      </div>
    </div>
  );
}
